import React, { useEffect, useState, useRef } from 'react'
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom'

import Events from '@st-operations/uikit/Events.js'

import ListView from '_components/list-view/index.jsx'
import Header from '_components/header/index.jsx'
import ContentRuleChangeRequestStatusBadge from '_components/content-rule-change-request-status-badge'

import { getEnumCreatedBy } from '_services/campaigns'

import './styles.scss'

const ContentRuleChangeRequests = () => {
  const history = useHistory()
  const listViewQuery = history.location.search?.substring(1)

  const [createdByOptions, setCreatedByOptions] = useState([])

  const listViewItemsRef = useRef([])

  useEffect(() => {
    getEnumCreatedBy().then(setCreatedByOptions)
  }, [])

  const handleSelectionChange = ({ action, items }) => {
    const selectedEntities = listViewItemsRef.current.filter(({ _id }) => items.includes(_id))
    Events.emit('ListView-selection', { action, items, entities: selectedEntities })
  }

  return (
    <div id="content-rule-change-requests-page" className="content-rule-change-requests">
      <Header title="Content Rule Change Requests" />
      <div className="batch-sidebar__list-view-wrapper">
        <ListView
          itemsRef={listViewItemsRef}
          onSelectionChange={handleSelectionChange}
          columns={[
            {
              name: 'Content Rule Name',
              link: '/content-rule-change-requests/:_id',
              key: 'content_rule.name',
              styles: {
                maxWidth: '400px',
                textAlign: 'left',
              },
              sortable: true,
            },
            {
              name: 'Status',
              key: 'status',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
              // eslint-disable-next-line react/display-name
              render: (item) => <ContentRuleChangeRequestStatusBadge status={item.status} />,
              sortable: true,
            },
            {
              name: 'Updated At',
              key: 'updated_at',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
              // eslint-disable-next-line react/display-name
              render: (item) => <span>{dayjs(item.created_at).format('MM/DD/YYYY HH:mm')}</span>,
              sortable: true,
            },
            {
              name: 'Created By',
              key: 'created_by.email',
              styles: {
                maxWidth: '200px',
                textAlign: 'left',
              },
            },
          ]}
          entities="content_rule_change_requests"
          searchable
          showCheckboxes={false}
          filters={[
            {
              name: 'status',
              label: 'Status',
              options: ['pending', 'approved', 'rejected', 'applied'],
              all: true,
            },
            {
              name: 'created_by.email',
              label: 'Created by',
              options: createdByOptions,
              all: true,
              className: 'audiences__filters',
            },
          ]}
          sort_key={'updated_at'}
          sort_dir={-1}
          q={listViewQuery}
          filter_on_load={listViewQuery ? false : { status: 'pending' }}
          dontStoreFilters
        />
      </div>
    </div>
  )
}

// export
export default ContentRuleChangeRequests
